import React from 'react';
import { useFindCurrentCountryRuleQuery } from '../../api';
import ShippingCityByGeoCodeField from './ShippingCityByGeoCodeField';
import ShippingCityByNameField from './ShippingCityByNameField';

const ShippingCityField = () => {

    const countryRules = useFindCurrentCountryRuleQuery();

    return countryRules.data?.geoCodeRequired ?
        <ShippingCityByGeoCodeField /> :
        <ShippingCityByNameField />;

};

export default ShippingCityField;
